module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNSAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjYxOTQgMS4yMDcwM0wxLjIwNjMgMTMuNjIwMSIgc3Ryb2tlPSIjMDg1NUM0IiBzdHJva2Utd2lkdGg9IjIuMDY4ODUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMS4yMDYzIDEuMjA3MDNMMTMuNjE5NCAxMy42MjAxIiBzdHJva2U9IiMwODU1QzQiIHN0cm9rZS13aWR0aD0iMi4wNjg4NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/nps/icon-close-nps-modal.svg
// module id = Vw2I
// module chunks = 1